export class User {
  id :number;
  email :string;
  firstname :string;
  lastname :string;
  photo_url :string;
  business_account_id :number;

  clear() {
    this.id = 0;
    this.email = '';
    this.firstname = '';
    this.lastname = '';
    this.photo_url = '';
    this.business_account_id = 0;
  }
}

export class Login {
  id :number;
  email :string;
  is_admin :number;
  business_account_id :number;
}
